import { render, staticRenderFns } from "./DashboardArea.vue?vue&type=template&id=2853b297&scoped=true&"
import script from "./DashboardArea.vue?vue&type=script&lang=js&"
export * from "./DashboardArea.vue?vue&type=script&lang=js&"
import style0 from "./DashboardArea.vue?vue&type=style&index=0&id=2853b297&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2853b297",
  null
  
)

export default component.exports